<template>
    <section class="hero">
        <div class="hero-body">
            <div class="column is-6-desktop is-offset-3-desktop is-10-tablet is-offset-1-tablet">
                <div class="box">
                    <form @submit.prevent="submit">
                        <h3 class="title is-spaced has-text-centered">NULSTIL KODEORD</h3>

                        <b-notification :active.sync="success" type="is-success" :closable="false">
                            {{ success }}
                        </b-notification>

                        <b-notification :active.sync="error" type="is-danger">
                            {{ error }}
                        </b-notification>

                        <b-field :label="$t('global.forms.password')"
                                 :type="{'is-danger': veeErrors.has('password')}"
                                 :message="veeErrors.first('password')">
                            <b-input v-model="password" type="password" name="password"
                                     v-validate="'required|min:8'" :data-vv-as="$t('global.forms.password')" password-reveal />
                        </b-field>

                        <div class="buttons is-right">
                            <button type="submit" class="button is-primary" :disabled="veeErrors.any()" >
                                <span>Opdater</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
    .hero {
        background: url('/static/backgrounds/white-bricks-people.jpeg') no-repeat center bottom;
        background-size: cover;
    }
</style>

<script>
    import ResetPasswordService from '@/infrastructure/auth/services/ResetPasswordService';

    export default {
        data() {
            return {
                token: null,
                password: null,
                error: null,
                success: null,
            };
        },

        mounted() {
            const { query } = this.$route;

            if (!query.token) {
                this.$router.push({ name: 'home' });
            }

            this.token = query.token;
        },

        methods: {
            submit() {
                this.$validator.validateAll().then((result) => {
                    if (!result) {
                        return;
                    }

                    const options = {
                        token: this.token,
                        password: this.password,
                    };

                    ResetPasswordService.change(options, () => {
                        this.success = 'Din kode er nu ændret og du kan logge ind med den.';
                    }, (error) => {
                        const { data } = error.response;

                        switch (data.message) {
                            case 'TOKEN_NOT_FOUND':
                                this.error = 'Du har allerede brugt dette nulstillings-link, eller også er det udløbet.';
                                break;

                            default:
                                this.error = 'Vi kunne ikke ændre din kode. Prøv venligst igen.';
                                break;
                        }
                    });
                });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/infrastructure/auth/pages/ResetPassword.vue